export default __webpack_public_path__ + "static/media/Garmin_VivoActive5.84161a5b.png";